import { render, staticRenderFns } from "./tank-view-control.vue?vue&type=template&id=61bb1b58&"
import script from "./tank-view-control.vue?vue&type=script&lang=js&"
export * from "./tank-view-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports